module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/music.json
// module id = 462
// module chunks = 192093361865127